import type { ExistingRoomEditDefault_EditPageQuery, LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { ProductExistingRoomFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/existing/use-init";
import { RoomFormMain } from "../_shared/components/root";
import { standardRoomCategoriesAndManagerStore } from "../_shared/store/categories";
import { HeaderActions } from "./components/header/actions";

type Props = {
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;

	serverModel: ExistingRoomEditDefault_EditPageQuery;
};

export const RoomEditPresenter = ({ activeLangCode, navigator, serverModel }: Props) => {
	const init = useInitialized({ serverModel });

	const { categoryManagerStore } = standardRoomCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const roomName = init.viewModel.name.value;

	return (
		<ProductExistingRoomFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="部屋の編集"
					activeLangCode={activeLangCode}
					navigator={navigator}
					rightChildren={<HeaderActions />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={roomName} />

					<RoomFormMain roomCategoriesAndManagerStore={standardRoomCategoriesAndManagerStore} />
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductExistingRoomFormModelContextProvider>
	);
};

RoomEditPresenter.displayName = "RoomEditPresenter";
